'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.REALITY_CHECK_DISABLED_VALUE = void 0;
exports.REALITY_CHECK_DISABLED_VALUE = 16666.65;
